require.register("app/product/price/NewView", function(exports, require, module){
  $0
  
});

